import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { useTheme } from '@mui/material/styles';
import ModalLarge from './Base/ModalLarge';
import Orders from '../stories/layout-components/templates/Orders';
import nodeAxiosFirebase from '../utils/nodeAxiosFirebase';

const ModalStoreConnectors = (props) => {
  const { t } = useTranslation();
  const {
    isOpen,
  } = props;

  const dispatch = useDispatch();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const [cart, setCart] = useState([]);
  const [selectedConnector, setSelectedConnector] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const businessPreference = useSelector((state) => state.core.businessData);
  const singleElementDetails = useSelector(
    (state) => state.element.singleElementDetails
  );

  const processOrder = (type) => {
    if (!cart.length || !selectedConnector) return;

    const orderData = {
      connector: selectedConnector.name,
      items: cart.map(item => ({
        productID: item.productID,
        productDesc: item.productDesc,
        quantity: item.quantity,
        price: item.price,
        listPrice: item.listPrice,
        totalPrice: item.totalPrice,
        brandID: item.brandID,
        quality: item.quality,
        photo: item.photo
      })),
      totalAmount: cart.reduce((sum, item) => sum + item.totalPrice, 0),
      customerInfo: {
        name: singleElementDetails?.targetName,
        phone: singleElementDetails?.targetPhone,
        vehicle: {
          name: singleElementDetails?.targetProfileDetails?.name,
          make: singleElementDetails?.targetProfileDetails?.attribute1,
          model: singleElementDetails?.targetProfileDetails?.attribute2,
          year: singleElementDetails?.targetProfileDetails?.attribute3
        }
      },
      orderDate: new Date().toISOString()
    };

    if (type === 'addToCart') {
      handleSubmitAddCard(orderData);
    } else {
      handleSubmitOrder(orderData);
    }
  };

  const handleSubmitOrder = async (orderData) => {
    if (!orderData || !orderData.connector) return;

    setIsProcessing(true);
    try {
      let response;

      switch (orderData.connector) {
        case 'WorldPAC':
          response = await nodeAxiosFirebase({
            t,
            method: 'POST',
            showLoading: true,
            url: 'https://extensionsext-kjeoh6r3gq-nn.a.run.app/worldpac',
            body: {
              data: {
                nomFonction: 'PlaceOrder',
                body: {
                  items: orderData.items.map(item => ({
                    productID: item.productID,
                    quantity: item.quantity,
                    price: item.price,
                    listPrice: item.listPrice
                  })),
                  customerInfo: orderData.customerInfo,
                  orderDate: orderData.orderDate,
                  totalAmount: orderData.totalAmount
                }
              }
            },
          });
          break;

        case 'VLN':
          response = await nodeAxiosFirebase({
            t,
            method: 'POST',
            showLoading: true,
            url: 'https://extensionsext-kjeoh6r3gq-nn.a.run.app/vln',
            body: {
              data: {
                nomFonction: 'placeOrder',
                body: {
                  items: orderData.items.map(item => ({
                    productID: item.productID,
                    quantity: item.quantity,
                    price: item.price,
                    listPrice: item.listPrice,
                    brandID: item.brandID,
                    quality: item.quality
                  })),
                  customerInfo: orderData.customerInfo,
                  orderDate: orderData.orderDate,
                  totalAmount: orderData.totalAmount
                }
              }
            },
          });
          break;

        default:
          throw new Error('Unsupported connector');
      }

      if (response?.errorData) {
        throw new Error(response.errorData);
      }


      setCart([]); // Clear cart after successful order

      // You might want to show a success message or redirect

    } catch (error) {
      console.error('Error placing order:', error);
      // Handle error (show error message to user)
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSubmitAddCard = async (orderData) => {
    if (!orderData || !orderData.connector) return;

    setIsProcessing(true);
    try {




    } catch (error) {
      console.error('Error adding to cart:', error);
      // Handle error (show error message to user)
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div>
      <ModalLarge
        title={t('connectors')}
        subTitle={t('ordersListing')}
        isOpen={isOpen}
        maxWidth={cart?.length > 0 ? 'xl' : 'lg'}
        fullWidth={true}
        fullHeight={true}
        {...props}
        labels={{
          primary: t('placeOrderAddToCard'),
          secondary: t('placeOrder'),
        }}
        handlePrim={() => handleSubmitAddCard(cart)}
        handleSec={() => processOrder(cart)}
        disabledPrim={!cart?.length || isProcessing}
        disabledSec={!cart?.length || isProcessing}
      >
        <div>
          <Orders
            cart={cart}
            setCart={setCart}
            setSelectedConnector={setSelectedConnector}
            selectedConnector={selectedConnector}
            handleSubmitAddCard={handleSubmitAddCard}
            handleSubmitOrder={handleSubmitOrder}
          />
        </div>
      </ModalLarge>
    </div>
  );
};

export default ModalStoreConnectors;
